import Service from "../Service";
import Vue from "vue";
const resource = "paymentterms/";

export default {
    getURLList() {
        return Vue.prototype.$http.defaults.baseURL + "/paymentterms/list";
    },
};